import React from 'react';
import NarrowStageWithLogo from 'commonComponents/Stages/NarrowStageWithLogo/NarrowStageWithLogo';
import SuccessMessage from 'commonComponents/forms/SuccessMessageWithExperts/SuccessMessageWithExperts';
import InfoBar from 'commonComponents/sections/FormBoxSection/InfoBar/InfoBar';
import FormBoxSection from 'commonComponents/sections/FormBoxSection/FormBoxSection';
import styles from '../pages.module.scss';

const ContactFormPage = ({
  banner,
  form,
  token,
  user,
  sitekey
}) => {
  const { sidebar, thankyou, experts } = form;

  const bannerProps = {
    ...banner,
    pageName: 'contactFormPage'
  };

  const expertsProps = [...experts];
  expertsProps.forEach(expert => expert.isPrimary = true);

  const contactFormProps = {
    form, token, sitekey, user,
    orderOfFields: ['name', 'email', 'phone', 'message'],
    contactPage: true,
    url: 'contact',
    successBlock: () => <SuccessMessage { ...thankyou } experts={ experts } />,
    sideBar: isShow => {
      return isShow && <InfoBar { ...sidebar } experts={ expertsProps } />;
    }
  };

  return (
    <div className={ styles.Page }>
      <NarrowStageWithLogo { ...bannerProps } />
      <FormBoxSection { ...contactFormProps } />
    </div>
  );
};

export default ContactFormPage;
